import DirectionCarIcon from './directions_car_black_24dp.svg';
import DirectionWalkIcon from './directions_walk_black_24dp.svg';
import DirectionBusIcon from './directions_bus_black_24dp.svg';
import DirectionBikeIcon from './directions_bike_black_24dp.svg';
import LineOutlineIcon from './line_outline.svg';
import FloorPlanIcon from './floor-plan.svg';

const Icon = {
  DirectionCarIcon,
  DirectionWalkIcon,
  DirectionBusIcon,
  DirectionBikeIcon,
  LineOutlineIcon,
  FloorPlanIcon,
};

export default Icon;
